import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import { useAuth } from "context/auth-context";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { checkAndupdateSurveyStatusApi, } from "./../../api/comman/SurveyRedirectApi";
import { ZAMPLIA_SURVEYS_VENDOR__ID } from "../../config/constants";
import { getsurveysPointApi } from "pages/SurveyComplete/surveycomplete_api";
import { JoinNowNew } from "components/JoinNowForm/JoinNowNew";
import { UserQuotafull } from "./UserQuotafull";
import { handleLogout } from "controller/logoutWithUrl";

export const Quotafull = () => {
  const { t } = useTranslation();
  const { auth, setAuth } = useAuth();
  const [searchParams] = useSearchParams();
  const [uid, setUid] = React.useState("");
  const [sid, setSid] = React.useState("");
  const [vid, setVid] = React.useState("");
  const [sessionId, setSessionId] = React.useState("");
  const [isHmacFailed, SetHmacFailed] = React.useState(false);
  const [currentUrl, setCurrentUrl] = React.useState("");
  const [hmacValue, setHmacValue] = React.useState("");
  const [guestLoading, setGueastLoading] = useState(false);
  const [isGuestUser, setIsGuestUser] = useState(2);
  const navigate = useNavigate();

  const fetchPoints = async (sessionId: string, rating: number, uid: string) => {
    setGueastLoading(true);
    const response = await getsurveysPointApi(sessionId, rating, uid);

    if (response.success === true) {
      setIsGuestUser(response?.isGuestUser);
      // Guest survey + logged in user
      if (response?.isGuestUser === 1 && auth?.panelistId) {
        await handleLogout(window.location.href, navigate, setAuth);
        return;
      }
    } else {
      setIsGuestUser(0);
    }
    setGueastLoading(false);
  };

  useQuery(
    ["checkAndupdateSurveyStatus"],
    () => checkAndupdateSurveyStatusApi(auth?.panelistId || uid, sid, vid, hmacValue, currentUrl, sessionId, "quotaFull"),
    {
      enabled: !!uid,
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        if (response?.isHamcFailed) {
          SetHmacFailed(true);
        }
      },
    }
  );

  useEffect(() => {
    const hmac = searchParams.get("hmac");
    const UID = searchParams.get("UID");
    const SID = searchParams.get("SID");
    const SESSION_ID = searchParams.get("SESSION_ID");
    const VID = ZAMPLIA_SURVEYS_VENDOR__ID;
    const params = new URLSearchParams(window.location.search);
    const uidParam = params.get("UID");
    const sessionIdParam = params.get("SESSION_ID");
    if (sessionIdParam) fetchPoints(sessionIdParam, 0, uidParam);

    if (UID && SID && VID) {
      setUid(UID);
      setSid(SID);
      setVid(VID);
      setSessionId(SESSION_ID);
      setCurrentUrl(`${window.location.origin}${window.location.pathname}?SID=${SID}&UID=${UID}&SESSION_ID=${SESSION_ID}`);
      if (hmac) setHmacValue(hmac);
    }
  }, []);

  return (
    <LoadingOverlay active={guestLoading} spinner text={t("claim.card.Loading")}>
      <div className="w-full">
        {isGuestUser === 1 ? (
          <JoinNowNew isGuest={1} />
        ) : isGuestUser === 0 ? (
          <UserQuotafull isHmacFailed={isHmacFailed} />
        ) : null}
      </div>

    </LoadingOverlay>
  );
};
